export { serializeState, parseState } from './url';
export const pageName = 'attack';
